import React from 'react';
import PropTypes from 'prop-types';
import Clipboard from 'react-clipboard.js';
import {
  Box,
  Button,
  ButtonVariant,
  Icon,
  IconName,
  Modal,
} from '@usealloy/component-library';

import { handleClipboardCopy } from '~/helpers/messages';


const RawResponseModalPropTypes = {
  response: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
};

class RawResponseModal extends React.Component {
  constructor(props) {
    super(props);

    ['handleClipboardCopy'].forEach(method => { this[method] = this[method].bind(this); });
  }


  handleClipboardCopy(event) {
    const { toggleModal } = this.props;
    toggleModal();
    handleClipboardCopy(event);
  }

  getFormattedResponse() {
    const { response } = this.props;
    try {
      return JSON.stringify(JSON.parse(response), null, 2);
    } catch (error) {
      return response;
    }
  }

  render() {
    const { toggleModal, isOpen } = this.props;
    const formattedResponse = this.getFormattedResponse();
    return (
      <Modal
        id="raw-response-modal"
        header={(
          <Box justifyContent="flex-start" gap={4}>
            <span>Raw Response</span>
            <Clipboard
              component="a"
              data-clipboard-text={formattedResponse}
              onSuccess={this.handleClipboardCopy}
            >
              <Box justifyContent="flex-start" alignItems="center">
                Copy Raw Response
                <Icon icon={IconName.Copy} color="var(--cl-juicyBlue-600)" />
              </Box>
            </Clipboard>
          </Box>
        )}
        isOpen={isOpen}
        onClose={toggleModal}
        primaryAction={(
          <Button
            variant={ButtonVariant.primary}
            onClick={toggleModal}
          >
            Close
          </Button>
        )}
      >
        <pre className="monospace-code-block smaller-text">{formattedResponse}</pre>
      </Modal>
    );
  }
}
RawResponseModal.propTypes = RawResponseModalPropTypes;

export default RawResponseModal;
